export enum Role {
    Administrator,
    BetaTester,
    Evaluator,
    CourseEditor,
    SuperEvaluator,
    ATLead,
    LeadTrainer,
    Registrar,
    Student,
    Trainer,
    Guide,
    Coach,
    QualiMaster,
    BootcampTrainee,
    CohortCaptain,
    ExamineManager,
    Explorer,
    LoropioGirlsExplorer,
    Applicant
}

export const roles = Object.values(Role).filter((v) => !isNaN(Number(v))) as number[]

export const studentRoles = [Role.Student, Role.BootcampTrainee, Role.Explorer, Role.LoropioGirlsExplorer] as number[]

export const isApplicant = (userRoles: Role[]) => {
    return userRoles.length === 1 && userRoles.find(_ => _ = Role.Applicant) !== undefined;
}